
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"80","height":"80","viewBox":"0 0 80 80","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M50.064 39.028c.897.599.885 1.92-.022 2.503l-7.663 4.924-6.666 4.053c-1.306.794-2.984-.111-3.038-1.639l-.612-17.39a1.192 1.192 0 011.613-1.156 72.709 72.709 0 0114.63 7.53l1.758 1.175z","fill":"#F4F1EF"}})])
          )
        }
      }
    